#!/usr/bin/env node
const fs = require("fs");
const archiver = require("archiver");
const path = require("path");
const { execSync } = require("child_process");
const findNodeModules = require("./helpers/findNodeModules");

const nodeModulesDir = findNodeModules(__dirname);

function zipIcons() {
  const outputPath = path.join(process.cwd(), "salesforce-lightning-design-system-icons.zip");
  const output = fs.createWriteStream(outputPath);

  const archive = archiver("zip", {
    zlib: { level: 9 }, // Sets the compression level.
  });

  output.on("close", function () {
    console.log(
      `salesforce-lightning-design-system-icons.zip has been created in the current directory. Total bytes: ${archive.pointer()}`
    );
  });

  archive.on("error", function (err) {
    throw err;
  });

  archive.pipe(output);

  const iconsDir = path.join(
    nodeModulesDir,
    "@salesforce-ux/design-system/assets/icons"
  );
  console.log(iconsDir);
  archive.directory(iconsDir, false);

  archive.finalize();
}

// Export the function for use in other files
module.exports = zipIcons;

// If the script is being executed directly (not required by another module), call zipIcons
if (!module.parent) {
  zipIcons();
}